import React, { useState, useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import yup from '../../../libs/yup/yup';
import Swal from 'sweetalert2';
import { Controller, useForm } from 'react-hook-form';
import CustomInput from '../../../components/input/CustomInput';
import { createCity } from '../../../api/sportaloka-client';
import SelectProvince from '../../../components/input/SelectProvince';

const defaultValues = {
  name: '',
  province: null
};

const schema = yup.object().shape({
  name: yup.string().label('Nama kota').required('${label} wajib diisi'),
  province: yup
    .object()
    .label('Provinsi')
    .shape({
      label: yup.string().required(),
      value: yup.string().required()
    })
    .required('${label} wajib dipilih')
});

function AddCityModal({ onSubmitted }) {
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const onSubmit = async (val) => {
    try {
      setLoading(true);
      await createCity(val.province.value, val.name);
      Swal.fire({
        title: 'Berhasil!',
        text: 'Kota berhasil ditambahkan',
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      reset();
      document.getElementById('closeModal').click();
      onSubmitted();
      setLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 409) {
        Swal.fire({
          title: 'Gagal!',
          text: `Kota '${val.name}' sudah ada di database`,
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      } else {
        Swal.fire({
          title: 'Gagal!',
          text: 'Periksa koneksi anda dan coba kembali.',
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleModalHidden = () => {
      reset();
    };

    const modalElement = document.getElementById('addCityModal');
    modalElement.addEventListener('hidden.bs.modal', handleModalHidden);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', handleModalHidden);
    };
  }, [reset]);

  return (
    <div className="modal" tabIndex="-1" id="addCityModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h5 className="modal-title">Buat Kota Baru</h5>
              <button
                id="closeModal"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <Controller
                control={control}
                name="name"
                render={({ field: { onChange, onBlur, value } }) => (
                  <div className="mb-20">
                    <CustomInput
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      type="text"
                      label="Nama Kota"
                      isError={Boolean(errors.name)}
                      isSolid={true}
                      errorMessage={Boolean(errors.name) && errors.name.message}
                    />
                  </div>
                )}
              />
              <Controller
                control={control}
                name="province"
                render={({ field: { onChange, onBlur, value } }) => (
                  <div className="mb-20">
                    <SelectProvince
                      onChange={onChange}
                      onBlur={onBlur}
                      type="text"
                      label="Pilih Provinsi"
                      value={value}
                      isError={Boolean(errors.province)}
                      isSolid={true}
                      errorMessage={Boolean(errors.province) && errors.province.message}
                    />
                  </div>
                )}
              />
            </div>
            <div className="modal-footer justify-content-center">
              <button
                disabled={loading}
                type="submit"
                className="btn btn-primary bg-blue-1 rounded-1">
                <i className="fa fa-plus mr-10"></i>
                <span className="fw-500">{loading ? 'Mohon tunggu...' : 'Tambahkan'}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddCityModal;
